export const COMPANY_NAME = "KILDOS Productions LLC";
export const COMPANY_SHORT = "Kildos Productions";
export const COMPANY_INITIALS = "KP";
export const COMPANY_ADDRESS_FULL = "2108 N ST STE N, SACRAMENTO, CA 95816";
export const COMPANY_LOCATION = "Sacramento, CA";
export const COMPANY_REGION = "Sacramento, California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=2108%20N%20ST%20STE%20N%2C%20SACRAMENTO%2C%20CA%2095816";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1600&q=85";

export const PROFILE_FACTS = [
  { "label": "Focus", "value": "Public profile" },
  { "label": "Service Area", "value": "Sacramento, California" },
  { "label": "Location", "value": "Sacramento, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "KILDOS Productions LLC" },
  { "label": "City / State", "value": "Sacramento, CA" },
  { "label": "Address", "value": "2108 N ST STE N, SACRAMENTO, CA 95816" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "TODO: Pillar 1", "body": "TODO: Customize." },
  { "icon": "✦", "title": "TODO: Pillar 2", "body": "TODO: Customize." },
  { "icon": "✿", "title": "TODO: Pillar 3", "body": "TODO: Customize." },
  { "icon": "❍", "title": "TODO: Pillar 4", "body": "TODO: Customize." },
];
